import React from 'react';
import { Camera } from 'lucide-react';

/**
 * V277.4: Empty state for photo preview in modals
 */
const PhotoPreviewEmpty: React.FC<{ message?: string }> = ({ 
  message = 'No photo yet' 
}) => (
  <div 
    style={{
      width: '100%',
      height: '100%',
      minHeight: '300px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '16px',
      background: 'linear-gradient(135deg, #374151 0%, #1f2937 100%)',
      borderRadius: '12px',
    }}
  >
    <div 
      style={{
        width: '80px',
        height: '80px',
        borderRadius: '50%',
        background: 'rgba(255, 255, 255, 0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Camera size={40} style={{ color: 'rgba(255, 255, 255, 0.5)' }} />
    </div>
    
    <div style={{ textAlign: 'center', padding: '0 16px' }}>
      <p style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '14px', margin: 0, fontWeight: 500 }}>
        {message}
      </p>
      <p style={{ color: 'rgba(255, 255, 255, 0.4)', fontSize: '12px', marginTop: '4px' }}>
        Use the buttons below to add one
      </p>
    </div>
  </div>
);

export default PhotoPreviewEmpty;

